import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Ad Aggregation List
 */
export class AdAggregationListValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Array<AdAggregationValueObject>} deps.items
   */

  getItems = () => this._items
}
